module.exports = __webpack_public_path__ + "assets/img/2604.440512c7.png";